import { StudioImage } from '../studio/UI';
import { Link } from 'react-router-dom';
import { useCart } from '../cartContext';
import { pieceName } from '../shopItems';
import TrimmedArtwork from './TrimmedArtwork';

const ProductCard = ({ item, plain = false }) => {
    const { addToCart } = useCart();
    const { name } = pieceName(item, { shop: true });

    return (
        <article className={plain ? 'productCard productCardPlain' : 'productCard'}>
            <div className="productCardMedia">
                <Link to={`/products/${item.id}`}>
                    {item.soldOut ? <span className="shopBadge shopBadgeSoldOut">Sold out</span> : null}
                    {!item.soldOut && item.badge ? <span className="shopBadge">{item.badge}</span> : null}
                    {plain ?
                        <TrimmedArtwork imageWidth={640} src={item.image} alt={name} />
                        :
                        <StudioImage src={item.image} alt={name} />
                    }
                </Link>
                {item.soldOut ?
                    <span className="productQuickAdd productQuickAddDisabled">Sold out</span>
                    :
                    <button
                        className="productQuickAdd"
                        type="button"
                        onClick={() => addToCart(item)}
                    >
                        Add to cart
                    </button>
                }
            </div>
            <div className="productCardBody">
                <Link className="productCardTitle" to={`/products/${item.id}`}>{name}</Link>
                {item.edition ? <div className="productCardMeta">{item.edition}</div> : null}
                <div className="productCardPrice">${Number(item.price).toFixed(2)}</div>
            </div>
        </article>
    );
};

export default ProductCard;
